export const LINK_MYHAILOV_PARTNERS = 'https://m-p-a.ru/nedvizhimost.html';
